import { ReactNode } from "react";

interface ColumnDragOverlayProps {
  label: ReactNode;
}

export const DraggingColumnHeader = ({ label }: ColumnDragOverlayProps) => {
  return (
    <div className="flex h-[84px] w-[220px] rotate-2 items-center justify-center overflow-hidden rounded-2xl border border-solid border-[#E0E0E0] bg-white/80 px-4 shadow-[0_4px_16px_5px_rgba(0,0,0,0.08)]">
      <span className="font-secondary text-dark truncate text-sm font-medium">
        {label}
      </span>
    </div>
  );
};
